import { render, staticRenderFns } from "./BreadcrumbList.vue?vue&type=template&id=3c00ef12"
import script from "./BreadcrumbList.vue?vue&type=script&lang=js"
export * from "./BreadcrumbList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports